module.exports = __webpack_public_path__ + "images/your-logical-fallacy-is-com@2x.png";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/your-logical-fallacy-is-com@2x.png
// module id = 166
// module chunks = 1